import React from "react";
import "../template-file-css/document-file-template.css";

export const NBT_ManiaAdult = ({ itemsRef, showErrorFor }) => {

   return (
      <form id='NBT_ManiaAdult' className='file-pdf-document'>
         <div className='file-template'>

            <h4>
               LEVEL 2-Mania-Adult*
            </h4>
            <h5>
               *Altman Self-Rating Mania Scale (ASRM)
            </h5>
            <table>
               <tr>
                  <td className="w-375">
                     <span className="eleHeader w-375;">Name:</span>
                     <input type="text" id="txtChild" name="txtChild" className="add-only" />
                  </td>
                  <td className="w-375">
                     <span className="eleHeader w-375;">Age:</span>
                     <input type="text" id="txtAge" name="txtAge" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <span className="eleHeader w-375;">Sex:</span>
                     <td className="w-100">
                        <input type="radio" id="rbPregnancy_Yes" name="rbPregnancy" className="add-only" value="1" />Male
                     </td>
                     <td className="w-100">
                        <input type="radio" id="rbPregnancy_No" name="rbPregnancy" className="add-only" value="0" />Female
                     </td>
                  </td>
                  <td className="w-375">
                     <span className="eleHeader w-375;">Date:</span>
                     <input type="date" id="txtDate" name="txtDate" className="add-only" />
                  </td>
               </tr>
            </table>
            <p>
               If the measure is being completed by an informant, what is your relationship with the individual receiving care?
               <input type="text" id="txtChild2" name="txtChild2" className="add-only" />
            </p>
            <p>
               In a typical week, approximately how much time do you spend with the individual receiving care?
               <input type="text" id="txtChild1" name="txtChild1" className="add-only" /> hours/week
            </p>
            <p>
               <strong>Instructions:</strong> On the DSM-5 Level 1 cross-cutting questionnaire you just completed, you indicated that during the past 2 weeks you (the
               individual receiving care) have been bothered by "sleeping less than usual, but still having a lot of energy" and/or "starting lots more
               projects than usual or doing more risky things than usual" at a mild or greater level of severity. The five statement groups or questions
               below ask about these feelings in more detail.
            </p>
            <p>
               <strong>1. Please read each group of statements/question carefully.</strong>
            </p>
            <p>
               2. Choose the one statement in each group that best describes the way you (the individual receiving care) have been feeling for
               the past week.
            </p>
            <p>
               3. Check the box (&#10003; or x) next to the number/statement selected.
            </p>
            <p>
               4. <strong>Please note: </strong>The word "occasionally" when used here means once or twice; "often" means several times or more and
               "frequently" means most of the time.
            </p>
            <table>
               <tr>
                  <td className="w-500">
                     <span className="eleHeader">Question 1</span>
                  </td>
                  <td className="w-250">
                     <span className="eleHeader">Clinician Use<br />Item score</span>
                  </td>
               </tr>
               <tr>
                  <td className="w-50">
                     <input type="checkbox" name="chkLegal2" id="chkLegal2" className="add-only" value="1" /> 1
                  </td>
                  <td className="w-450">
                     I do not feel happier or more cheerful than usual.
                  </td>
                  <td className="w-250">
                     <input type="text" id="txtDomain2" name="txtDomain2" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-50">
                     <input type="checkbox" name="chkLegal3" id="chkLegal3" className="add-only" value="1" /> 2
                  </td>
                  <td className="w-450">
                     I occasionally feel happier or more cheerful than usual.
                  </td>
                  <td className="w-250">
                     <input type="text" id="txtDomain3" name="txtDomain3" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-50">
                     <input type="checkbox" name="chkLegal4" id="chkLegal4" className="add-only" value="1" /> 3
                  </td>
                  <td className="w-450">
                     I often feel happier or more cheerful than usual.
                  </td>
                  <td className="w-250">
                     <input type="text" id="txtDomain4" name="txtDomain4" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-50">
                     <input type="checkbox" name="chkLegal5" id="chkLegal5" className="add-only" value="1" /> 4
                  </td>
                  <td className="w-450">
                     I feel happier or more cheerful than usual most of the time.
                  </td>
                  <td className="w-250">
                     <input type="text" id="txtDomain5" name="txtDomain5" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-50">
                     <input type="checkbox" name="chkLegal6" id="chkLegal6" className="add-only" value="1" /> 5
                  </td>
                  <td className="w-450">
                     I feel happier of more cheerful than usual all of the time.
                  </td>
                  <td className="w-250">
                     <input type="text" id="txtDomain6" name="txtDomain6" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-750">
                     <span className="eleHeader">Question 2</span>
                  </td>
               </tr>
               <tr>
                  <td className="w-50">
                     <input type="checkbox" name="chkLegal7" id="chkLegal7" className="add-only" value="1" /> 1
                  </td>
                  <td className="w-450">
                     I do not feel more self-confident than usual.
                  </td>
                  <td className="w-250">
                     <input type="text" id="txtDomain7" name="txtDomain7" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-50">
                     <input type="checkbox" name="chkLegal8" id="chkLegal8" className="add-only" value="1" /> 2
                  </td>
                  <td className="w-450">
                     I occasionally feel more self-confident than usual.
                  </td>
                  <td className="w-250">
                     <input type="text" id="txtDomain8" name="txtDomain8" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-50">
                     <input type="checkbox" name="chkLegal9" id="chkLegal9" className="add-only" value="1" /> 3
                  </td>
                  <td className="w-450">
                     I often feel more self-confident than usual.
                  </td>
                  <td className="w-250">
                     <input type="text" id="txtDomain9" name="txtDomain9" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-50">
                     <input type="checkbox" name="chkLegal11" id="chkLegal11" className="add-only" value="1" /> 4
                  </td>
                  <td className="w-450">
                     I frequently feel more self-confident than usual.
                  </td>
                  <td className="w-250">
                     <input type="text" id="txtDomain11" name="txtDomain11" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-50">
                     <input type="checkbox" name="chkLegal12" id="chkLegal12" className="add-only" value="1" /> 5
                  </td>
                  <td className="w-450">
                     I feel extremely self-confident all of the time.
                  </td>
                  <td className="w-250">
                     <input type="text" id="txtDomain12" name="txtDomain12" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-750">
                     <span className="eleHeader">Question 3</span>
                  </td>
               </tr>
               <tr>
                  <td className="w-50">
                     <input type="checkbox" name="chkLegal13" id="chkLegal13" className="add-only" value="1" /> 1
                  </td>
                  <td className="w-450">
                     I do not need less sleep than usual.
                  </td>
                  <td className="w-250">
                     <input type="text" id="txtDomain13" name="txtDomain13" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-50">
                     <input type="checkbox" name="chkLegal14" id="chkLegal14" className="add-only" value="1" /> 2
                  </td>
                  <td className="w-450">
                     I occasionally need less sleep than usual.
                  </td>
                  <td className="w-250">
                     <input type="text" id="txtDomain14" name="txtDomain14" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-50">
                     <input type="checkbox" name="chkLegal15" id="chkLegal15" className="add-only" value="1" /> 3
                  </td>
                  <td className="w-450">
                     I often need less sleep than usual.
                  </td>
                  <td className="w-250">
                     <input type="text" id="txtDomain15" name="txtDomain15" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-50">
                     <input type="checkbox" name="chkLegal16" id="chkLegal16" className="add-only" value="1" /> 4
                  </td>
                  <td className="w-450">
                     I frequently need less sleep than usual.
                  </td>
                  <td className="w-250">
                     <input type="text" id="txtDomain16" name="txtDomain16" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-50">
                     <input type="checkbox" name="chkLegal17" id="chkLegal17" className="add-only" value="1" /> 5
                  </td>
                  <td className="w-450">
                     I can go all day and all night without any sleep and still not feel tired.
                  </td>
                  <td className="w-250">
                     <input type="text" id="txtDomain17" name="txtDomain17" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-750">
                     <span className="eleHeader">Question 4</span>
                  </td>
               </tr>
               <tr>
                  <td className="w-50">
                     <input type="checkbox" name="chkLegal18" id="chkLegal18" className="add-only" value="1" /> 1
                  </td>
                  <td className="w-450">
                     I do not talk more than usual.
                  </td>
                  <td className="w-250">
                     <input type="text" id="txtDomain18" name="txtDomain18" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-50">
                     <input type="checkbox" name="chkLegal19" id="chkLegal19" className="add-only" value="1" /> 2
                  </td>
                  <td className="w-450">
                     I occasionally talk more than usual.
                  </td>
                  <td className="w-250">
                     <input type="text" id="txtDomain19" name="txtDomain19" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-50">
                     <input type="checkbox" name="chkLegal20" id="chkLegal20" className="add-only" value="1" /> 3
                  </td>
                  <td className="w-450">
                     I often talk more than usual.
                  </td>
                  <td className="w-250">
                     <input type="text" id="txtDomain20" name="txtDomain20" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-50">
                     <input type="checkbox" name="chkLegal21" id="chkLegal21" className="add-only" value="1" /> 4
                  </td>
                  <td className="w-450">
                     I frequently talk more than usual.
                  </td>
                  <td className="w-250">
                     <input type="text" id="txtDomain21" name="txtDomain21" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-50">
                     <input type="checkbox" name="txtDomain22" id="txtDomain22" className="add-only" value="1" /> 5
                  </td>
                  <td className="w-450">
                     I talk constantly and cannot be interrupted.
                  </td>
                  <td className="w-250">
                     <input type="text" id="txtDomain221" name="txtDomain221" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-750">
                     <span className="eleHeader">Question 5</span>
                  </td>
               </tr>
               <tr>
                  <td className="w-50">
                     <input type="checkbox" name="chkLegal24" id="chkLegal24" className="add-only" value="1" /> 1
                  </td>
                  <td className="w-450">
                     I have not been more active (either socially, sexually, at work, home, or school) than usual.
                  </td>
                  <td className="w-250">
                     <input type="text" id="txtDomain24" name="txtDomain24" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-50">
                     <input type="checkbox" name="chkLegal25" id="chkLegal25" className="add-only" value="1" /> 2
                  </td>
                  <td className="w-450">
                     I have occasionally been more active than usual.
                  </td>
                  <td className="w-250">
                     <input type="text" id="txtDomain25" name="txtDomain25" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-50">
                     <input type="checkbox" name="chkLegal26" id="chkLegal26" className="add-only" value="1" /> 3
                  </td>
                  <td className="w-450">
                     I have often been more active than usual.
                  </td>
                  <td className="w-250">
                     <input type="text" id="txtDomain26" name="txtDomain26" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-50">
                     <input type="checkbox" name="chkLegal27" id="chkLegal27" className="add-only" value="1" /> 4
                  </td>
                  <td className="w-450">
                     I have frequently been more active than usual.
                  </td>
                  <td className="w-250">
                     <input type="text" id="txtDomain27" name="txtDomain27" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-50">
                     <input type="checkbox" name="chkLegal28" id="chkLegal28" className="add-only" value="1" /> 5
                  </td>
                  <td className="w-450">
                     I am constantly more active or on the go all the time.
                  </td>
                  <td className="w-250">
                     <input type="text" id="txtDomain28" name="txtDomain28" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-500 text-right">
                     <strong>Total/Partial Raw Score:</strong>
                  </td>
                  <td className="w-250">
                     <input type="text" id="txtPartialRaw29" name="txtPartialRaw29" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-500 text-right">
                     <strong>Prorated Total Raw Score:</strong>
                  </td>
                  <td className="w-250">
                     <input type="text" id="txtPartialRaw30" name="txtPartialRaw30" className="add-only" />
                  </td>
               </tr>
            </table>
            <p>
               <strong>Instructions to Clinicians</strong>
            </p>
            <p>
               The DSM-5 Level 2-Mania-Adult measure is the Altman Self-Rating Mania Scale. The ASRM is a 5-item selfrating
               mania scale designed to assess the presence and/or severity of manic symptoms. The measure is
               completed by the individual prior to a visit with the clinician. If the individual receiving care is of impaired
               capacity and unable to complete the form (e.g., an individual with dementia), a knowledgeable informant may
               complete the measure. Each item asks the individual (or informant) to rate the severity of the individual's
               manic symptoms during the past 7 days.
            </p>
            <p>
               <strong>Scoring and Interpretation</strong>
            </p>
            <p>
               Each item on the measure is rated on a 5-point scale (i.e., 1 to 5) with the response categories having different
               anchors depending on the item. The ASRM score range from 5 to 25 with higher scores indicating greater
               severity of manic symptoms. The clinician is asked review the score on each item on the measure during the
               clinical interview and indicate the raw score for each item in the section provided for "Clinician Use". The raw
               scores on the 5 items should be summed to obtain a total raw score and should be interpreted using the
               Interpretation Table for the ASRM below:
            </p>
            <p>
               <strong>Interpretation Table for the ASRM</strong>
            </p>
            <ul>
               <li>
                  A score of 6 or higher indicates a high probability of a manic or hypomanic condition
               </li>
               <li>
                  A score of 6 or higher may indicate a need for treatment and/or further diagnostic workup
               </li>
               <li>
                  A score of 5 or lower is less likely to be associated with significant symptoms of mania
               </li>
            </ul>
            <p>
               <strong>Note:</strong> If 2 or more items are left unanswered on the measure (i.e., more than 25% of the total items are
               missing) the scores should not be used. As such, the individual (or informant) should be encouraged to
               complete all of the items on the measure. If only 4 of the 5 items on the measure are answered, you are asked
               to calculate a prorated score. The prorated score is calculated by summing the scores of items that were
               answered to get a partial raw score. Next, multiply the partial raw score by the total number of items on the
               ASRM (i.e., 5). Finally, divide the value by the number of items that were actually answered (i.e.,4).
            </p>
            <p>
               <b>Prorated score =</b> (Partial Raw Score x number of items on the ASRM)/Number of items that were actually answered
            </p>
            <p>
               If the result is a fraction, round to the nearest whole number.
            </p>
            <p>
               The prorated total raw score should be interpreted using the Interpretation Table for the ASRM above.
            </p>
            <p>
               <strong>Frequency of Use</strong>
            </p>
            <p>
               To track change in the severity of the individual's manic symptoms over time, the measure may be completed
               at regular intervals as clinically indicated, depending on the stability of the individual's symptoms and
               treatment status. For individuals of impaired capacity, it is preferred that completion of the measures at
               follow-up appointments is by the same knowledgeable informant. Consistently high scores on a particular
               domain may indicate significant and problematic areas for the patient that might warrant further assessment,
               treatment, and follow-up. Your clinical judgment should guide your decision.
            </p>
         </div>
      </form>
   )
}